import React from 'react';
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from 'react-router-dom';

import Header from './components/Header';
import Footer from './components/Footer';
import Home from './routes/Home';
import About from './routes/About';
import Products from './routes/Products';
import Notification from './routes/Notification';
import Commitment from './routes/Commitment';
import Detail from './routes/Detail';
import Seller from './routes/Seller';
import Member from './routes/Member';
import Media from './routes/Media';
import ScrollToTop from './ScrollToTop';

// eslint-disable-next-line import/no-anonymous-default-export
export default () => (
  <Router>
    <ScrollToTop />
    <Header />
    <Switch>
      <Route path="/" exact component={Home} />
      <Route path="/about" exact component={About} />
      <Route path="/products" exact component={Products} />
      <Route path="/products/:section/:path" exact component={Products} />
      <Route path="/detail/:id" exact component={Detail} />
      <Route path="/notification" exact component={Notification} />
      <Route path="/commitment" exact component={Commitment} />
      <Route path="/seller" exact component={Seller} />
      <Route path="/member" exact component={Member} />
      <Route path="/media" exact component={Media} />
      <Redirect from="*" to="/" />
    </Switch>
    <Footer />
  </Router>
);
